export default {
  provider: "Provider",
  not_especified: "--",
};
